import React, { useState, useEffect } from 'react';
import { API_BASE_URL, renderModal, closeModal, chartGroups, GraphicGroupSelector, GraphicTypeContainers, ChartWidget, ListWithDatasetSelector} from './Common';
import './ChartWidgetCreator.css';

import axios from 'axios';


function ChartWidgetCreator({
widget,
tableColumnData,
  isTablesLoaded,
  tables,
projectId,
setWidgets
}) {

  const widgetId = Object.keys(widget)[0];

function get_table_id(column_id) {
  for (const tableId in tables) {
    const table = tables[tableId];
    for (const column of table.columns) {
      if (column.column_id === column_id) {
        return table.table_id;
      }
    }
  }
}

  const [selectedDatasets, setselectedDatasets] = useState(widget[widgetId].columns.map(columnId => String(columnId)));
  const [selectedTable, setSelectedTable] = useState(get_table_id(widget[widgetId].label_id).toString());
  const [selectedColumn, setSelectedColumn] = useState(widget[widgetId].label_id.toString());
  const [graphType, setGraphType] = useState(widget[widgetId].graph_type.toString());
  const [newWidgetName, setnewWidgetName] = useState(widget[widgetId].name.toString());

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [modalIconId, setModalIconId] = useState(1);
  const [selectedGroup, setSelectedGroup] = useState(null);

  useEffect(() => {
  if (!graphType) return;

  const groupIndex = chartGroups.findIndex(group => group && group[graphType]);

  setSelectedGroup(groupIndex === -1 ? null : groupIndex);
}, [graphType]);



const handleCreateWidget = async () => {
  try {
    const token = localStorage.getItem('token');

const newWidgetData = {
      projectId: projectId,
      graphType: graphType,
      label: selectedColumn,
      name: newWidgetName,
      dataset: selectedDatasets
    };

    const response = await axios.put(`${API_BASE_URL}/widgets/${widgetId}`, newWidgetData, {
      headers: {
        Authorization: `Bearer ${token}` // Include JWT token in Authorization header
      }
    });

    const firstKey = Object.keys(response.data.duplicatedWidget)[0];
    const newWidget = response.data.duplicatedWidget[firstKey];
    setWidgets(prevWidgets => ({ ...prevWidgets, [firstKey]: newWidget }));

    setModalMessage("Widget atualizado!");
      setModalMessageColor('#41BBC9');
      setModalIconId(1);
      setIsModalOpen(true);

  } catch (error) {
    setModalMessage("Erro ao atualizar widget...");
      setModalMessageColor('#E5004E');
      setModalIconId(2);
      setIsModalOpen(true);
  }
};


  return (
  <div className="home-container" style={{ paddingLeft: '0px', paddingTop: '0px' }}>
      <h2>Gerir widgets</h2>
      <p>Atualizar widget</p>

    <div className="create-project">
    <label className="project-name-label">Nome do Widget</label>

    <input type="text"
    placeholder="Inserir nome do widget"
    value={newWidgetName}
    onChange={(e) => setnewWidgetName(e.target.value)} />

{/* ************************************************* Tabela ****************************/}
    <ListWithDatasetSelector
      data={tables}
      selectedData={selectedTable}
      setSelectedData={setSelectedTable}
      isDataLoaded={isTablesLoaded}
      selectedColumn={selectedColumn}
      setSelectedColumn={setSelectedColumn}
      selectedDatasets={selectedDatasets}
      setSelectedDatasets={setselectedDatasets}
    />

    <GraphicGroupSelector
  selectedGroup={selectedGroup}
  setSelectedGroup={setSelectedGroup}
  setGraphType={setGraphType}
/>


<GraphicTypeContainers
  selectedDatasets={selectedDatasets}
  tableColumnData={tableColumnData}
  setGraphType={setGraphType}
  graphType={graphType}
  selectedGroup={selectedGroup}
/>

    <ChartWidget
  tableColumnData={tableColumnData}
  buttonLabel="Atualizar Widget"
  onButtonClick={handleCreateWidget}
  graphType={graphType}
  selectedColumn={selectedColumn}
  selectedDatasets={selectedDatasets}
  tables={tables}
  height="300px"
/>

{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}
  </div>
  </div>
);

}



export default ChartWidgetCreator;
